import { useEffect } from 'react';
import { motion } from 'framer-motion';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_77c7e095-6aee-4db7-89db-d1905485427a/artifacts/rg0086kf_Untitled%20design%20%283%29.png";

export const SplashLoader = ({ onComplete }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, 2500);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <motion.div
      data-testid="splash-loader"
      className="fixed inset-0 z-[100] bg-white flex items-center justify-center"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="relative">
        {/* Logo Animation */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="relative site-logo"
        >
          <motion.img
            src={LOGO_URL}
            alt="biomstudio"
            className="h-28 md:h-32 w-auto object-contain mix-blend-multiply"
            initial={{ filter: 'blur(10px)' }}
            animate={{ filter: 'blur(0px)' }}
            transition={{ duration: 1.2, delay: 0.3 }}
          />
        </motion.div>

        {/* Loading Line */}
        <motion.div
          className="absolute -bottom-8 left-0 right-0 h-[1px] bg-stone-300 overflow-hidden"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <motion.div
            className="h-full bg-stone-900"
            initial={{ width: '0%' }}
            animate={{ width: '100%' }}
            transition={{ duration: 1.5, delay: 0.7, ease: [0.22, 1, 0.36, 1] }}
          />
        </motion.div>
      </div>
    </motion.div>
  );
};
